export class Routine {
    creationDate: string;
    houseId: string;
    name: string;
    routineId: string;
    lastTriggered: Date | null;
    config: Array<RoutineDevice>;
}

export class RoutineDevice {
   moduleId: string;
   name?: string;
   command: CommandRoutine;
}

export class CommandRoutine {
    relayState: boolean;
 }


// WEBPACK FOOTER //
// ./src/app/entities/routines/routines.model.ts